<div class="flex flex-row gap-4">
  <div [formGroup]="issueFormGroup" class="w-full form flex flex-col">

    <nx-edit-select-input
        formControlName="type"
        [options]="issueTypeOptions"
        [label]="'Typ'">
    </nx-edit-select-input>
    <nx-edit-text-input
      formControlName="title"
      label="Titel">
    </nx-edit-text-input>
    <nx-edit-tipTap-input
      formControlName="description"
      label="Beschreibung">
    </nx-edit-tipTap-input>

  </div>

  <div class="w-4/12 form flex flex-col" [formGroup]="issueFormGroup">
    <nx-label-widget-input
      formControlName="labels"
      class="mb-2">
    </nx-label-widget-input>

  <nx-issue-location-widget-input
    formControlName="location">
  </nx-issue-location-widget-input>

    <!-- Dynamically rendered entity links based on configuration -->
    <ng-container *ngFor="let config of currentEntityLinkConfigs">

      <!-- Single Widget -->
      <nx-single-entity-link-widget-input
        *ngIf="!config.multiple"
        [formControlName]="config.role"
        [linkedEntityType]="config.linkedEntityType"
        [linkType]="config.linkType"
        [label]="config.label"
        [placeholder]="config.placeholder"
        [role]="config.role">
      </nx-single-entity-link-widget-input>

      <!-- Multi Widget -->
      <nx-multi-entity-link-widget-input
        *ngIf="config.multiple"
        [formControlName]="config.role"
        [linkedEntityType]="config.linkedEntityType"
        [linkType]="config.linkType"
        [label]="config.label"
        [placeholder]="config.placeholder"
        [role]="config.role">
      </nx-multi-entity-link-widget-input>

    </ng-container>
  </div>



</div>
